const NETWORK_EVENTS = {
  NOT_FOUND: 'NETWORK_EVENTS.NOT_FOUND',
  FORBIDDEN: 'NETWORK_EVENTS.FORBIDDEN',
};

export default NETWORK_EVENTS;
